module.exports = __webpack_public_path__ + "static/media/state-farm-ad-2.24b50461.png";